import React, { Component } from "react";
import { Collapse } from "antd";
import "./style.css";

const { Panel } = Collapse;

function callback(key) {
  console.log(key);
}

class Mission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Dummy: [],
    };
  }

  componentDidMount() {
    this.setState({ Dummy: this.props.payload });
    console.log("dummy data will here", this.state.Dummy);
  }

  render() {
    return (
      <div className="faqMainBox animate__animated animate__fadeIn">
        <Collapse collapsible="disabled">
          <Panel
            showArrow={false}
            className="tc"
            header="Information Technology (IT) - FAQs"
          ></Panel>
        </Collapse>
        <Collapse className="faqInnerBox" onChange={callback}>
          {this.state.Dummy.map((item, index) => {
            return (
              <Collapse header={item.question}>
                <Panel header={item.question} key={index}>
                  <p>{item.answer}</p>s
                </Panel>
              </Collapse>
            );
          })}
        </Collapse>
      </div>
    );
  }
}
export default Mission;
